import { Injectable } from '@angular/core';
import { ServiceBase, OrigamiResponse } from './base/service.base';
import { Observable } from 'rxjs';

export namespace LMSServiceOptions {
  export interface GetCourses {
    siteId: number;
  }
}

export namespace InvestigativeSiteModel {
  export interface Courses {
    accesslink: string;
    completeddate: string;
    duedate: string;
    fullname: string;
    id: number;
    progress: number;
    shortname: string;
    status: string;
  }
}

@Injectable()
export class LMSService extends ServiceBase {
  serviceUrl = 'LMSService.svc';

  getCourses(
    body: LMSServiceOptions.GetCourses,
    ...params
  ): Observable<OrigamiResponse<InvestigativeSiteModel.Courses[]>> {
    return this.origamiPost('/GetCourses', body, ...params);
  }
}
